import React, { useContext } from "react";

// Asssets
import lommetorkleImage from "sass/images/lommetorkle.jpg";

// External components
import SimpleReactLightbox, {
    SRLWrapper,
    useLightbox,
} from "simple-react-lightbox";

// Contexts
import { DataContext } from "contexts/Data";
const Lommetorkle = (props) => {
    const { language, data } = useContext(DataContext);
    const options = {
        settings: { lightboxTransitionSpeed: 0, slideTransitionSpeed: 0 },
    };
    const Comp = ({ images }) => {
        const names = [
            "turid_erikstad",
            "grini",
            "year",
            "berit_andersen",
            "tone_kassim",
            "hildur_rasmussen",
            "kroken",
            "inger_johanne",
            "margrethe",
            "tordis_erikstad",
            "inger_borgen",
            "gun_enger",
            "kinken",
            "anna_fadijr",
            "bjorg",
            "signe_sørensen",
            "helga",
            "sudrum_lauskogen",
            "anna_johannesen",
            "randi_blom",
            "solveig_ludvigsen",
            "rosa",
            "elsa_bergh",
            "asta_brant",
            "maja_larsen",
            "jerda_hermansen",
        ];
        const { openLightbox } = useLightbox();
        const capitalize = (input) => {
            return input
                .toLowerCase()
                .split(" ")
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(" ");
        };
        return (
            <>
                <div>
                    <SRLWrapper options={options}>
                        {names.map((name) => (
                            <img
                                style={{ display: "none" }}
                                width="100%"
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/lommetorkle/${name}.jpg`
                                }
                                alt={`Grini ${
                                    language === "no" ? "lommetørkle" : ""
                                } ${
                                    language === "en" ? "handkerchief" : ""
                                } - ${capitalize(name.replace(/_/g, " "))}`}
                            />
                        ))}
                    </SRLWrapper>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1088.7 1026.3"
                        className="lommetorkle"
                    >
                        <defs>
                            <clipPath id="lommetorkle-clip">
                                <path
                                    d="M378,68.7c30.68.58,58.74,3.48,89.7,7.2,30.11,3.62,61.4-.91,88.5,2.1L600,82.8l23.7-1.2c30.93,4.05,65.77,1.29,94.2,4.5,26.8,3,59.52,0,85.8-3.6,10.06-1.39,24,1.52,34.2.6l27.3-2.7C897.75,86.92,932,88,969,87.9l45.6-.3,28.2.6,76.5-3.3,22.5,1.5,63-.3c27.22-1.19,58.53-7.24,89.7-3.3l28.8-.3c12.4,1.82,16.39,16.49,28.5,12.6,10,29-17,75.87-.6,106.5l3,10.5c2.2,1.79,0,22.9,1.8,26.1l-4.2,6.9c-1.53,4.06,3.75,38.45,3.6,44.1-.07,2.53.16,2,1.2,2.7l.3,19.5c1.67,7.05,6.95,11.62,8.7,18l-.9,1.8c-1.4,3.17.11,4.45-3.3,7.8,4,5.28-2,52.74-1.2,60.3,3.55,32,10.22,67.27,12.9,103.2,0,0,.3,40.44,1.8,47.1,5.06,22.41-.93,48.87,5.1,74.7,3.36,14.4,4.16,32.4,10.5,44.4,1.54,2.92-1.44,17.53-.6,25.5l6.3,18.6-5.4,22.2c1.34,6.19,1.45,22.86-.9,25.2,5.51,9.29,3.38,27.62,6.9,48.3,6.33,37.23,10.79,76.48,19.5,113.4l2.1,29.7,17.4,85.8c4.12,13.08.65,21.07,6.6,32.4l-2.1,3.9-52.5,1.8-72.9-3.9-42.3-1.8-54-4.2-33.3,1.2-91.8-3.6-56.4,1.8-48-.3c-30.6,2-58.28,5.42-90.9,7.2l-93-1.5-33.3,4.8-24.6-2.7c-10.66,4.41-20.2.53-32.1,3l-14.7,2.7c-4-.54-7.6-3.32-14.1-2.1-12.79,2.41-26.24,5-36.6,6.6-5.79.88-14.61-1.85-21.9-.9-19.67,2.57-38.3,3.55-60.9-.6l-20.1.6c-32.32,3.4-63.27-1.83-93.9,3.9l-22.8-1.5c-15.46,3.9-39.63,4.55-52.5,10.8-18.55-34.87-11.5-118.29-9-164.4,1.2-22.06-4.75-52.55-.6-78.6l.6-29.7c3.63-23.68,4.82-45.67,2.4-69.9l1.8-47.7-1.5-90.9c-2.17-25.1,2.89-40.67,1.8-61.5l-1.5-99-2.4-16.8.9-39.3-3.3-53.4-.6-40.2c3-15.93,2.27-53.91-1.8-70.5l.3-23.4c0-18-.25-35.89-3.3-52.8-2.12-11.75-2.75-56.63-7.8-59.4C354.07,95.45,375.47,70.51,378,68.7Z"
                                    transform="translate(-353.7 -68.7)"
                                />
                            </clipPath>
                        </defs>
                        <image
                            href={lommetorkleImage}
                            clipPath="url(#lommetorkle-clip)"
                            preserveAspectRatio="xMidYMid slice"
                            x="-0.5%"
                            y="-0.5%"
                            width="101%"
                            height="101%"
                            alt={`Grini ${
                                language === "no" ? "lommetørkle" : ""
                            } ${language === "en" ? "handkerchief" : ""}`}
                        />
                        <g
                            className="lommetorkle__area"
                            id="turid_erikstad"
                            // onClick={() => setModal("turid_erikstad")}
                            onClick={() =>
                                openLightbox(names.indexOf("turid_erikstad"))
                            }
                        >
                            <polygon points="686.66 859.03 716.38 908.58 584.6 920.47 358.69 905.6 358.69 851.11 522.18 851.11 559.83 875.88 622.25 872.9 686.66 859.03" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="grini"
                            // onClick={() => setModal("grini")}
                            onClick={() => openLightbox(names.indexOf("grini"))}
                        >
                            <polygon points="497.74 589.86 474.62 635.44 320.05 573.35 368.27 470.96 435.65 493.42 497.74 589.86" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="year"
                            // onClick={() => setModal("year")}
                            onClick={() => openLightbox(names.indexOf("year"))}
                        >
                            <polyline points="706.47 748.39 639.1 709.42 700.09 625.31 602.77 513.15 656.93 488.8 766.58 613.42 706.47 748.39" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="berit_andersen"
                            // onClick={() => setModal("berit_andersen")}
                            onClick={() =>
                                openLightbox(names.indexOf("berit_andersen"))
                            }
                        >
                            <polygon points="851.79 646.01 745.68 782.74 745.68 808.5 733.56 815.11 713.74 801.24 622.25 872.9 582.96 874.78 582.96 851.11 706.47 748.39 837.26 576.65 851.79 646.01" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="tone_kassim"
                            // onClick={() => setModal("tone_kassim")}
                            onClick={() =>
                                openLightbox(names.indexOf("tone_kassim"))
                            }
                        >
                            <polygon points="917.19 620.25 851.79 576.65 872.93 537.02 917.19 233.82 979.28 245.05 955.5 562.78 917.19 620.25" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="hildur_rasmussen"
                            // onClick={() => setModal("hildur_rasmussen")}
                            onClick={() =>
                                openLightbox(names.indexOf("hildur_rasmussen"))
                            }
                        >
                            <polygon points="237.49 416.14 224.93 352.72 217.01 276.76 170.77 282.04 193.23 641.38 232.2 635.44 237.49 416.14" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="kroken"
                            // onClick={() => setModal("kroken")}
                            onClick={() =>
                                openLightbox(names.indexOf("kroken"))
                            }
                        >
                            <polygon points="616.64 601.75 435.65 493.42 368.27 470.96 483.87 399.62 537.54 492.1 633.81 570.04 616.64 601.75" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="inger_johanne"
                            // onClick={() => setModal("inger_johanne")}
                            onClick={() =>
                                openLightbox(names.indexOf("inger_johanne"))
                            }
                        >
                            <polygon points="894.73 165.79 870.29 200.8 751.39 136.72 592.2 66.04 613.34 42.27 861.7 118.23 894.73 165.79" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="margrethe"
                            // onClick={() => setModal("margrethe")}
                            onClick={() =>
                                openLightbox(names.indexOf("margrethe"))
                            }
                        >
                            <polygon points="900.68 270.9 868.97 324.42 538.03 147.95 575.69 112.94 810.84 227.22 835.28 226.56 851.79 245.05 900.68 270.9" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="tordis_erikstad"
                            // onClick={() => setModal("tordis_erikstad")}
                            onClick={() =>
                                openLightbox(names.indexOf("tordis_erikstad"))
                            }
                        >
                            <polygon points="299.58 82.56 90.84 233.82 69.04 195.51 277.78 45.57 299.58 82.56" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="inger_borgen"
                            // onClick={() => setModal("inger_borgen")}
                            onClick={() =>
                                openLightbox(names.indexOf("inger_borgen"))
                            }
                        >
                            <polygon points="353.96 818.63 302.44 857.38 191.91 732.32 182.22 664.94 247.83 653.49 265.89 713.38 353.96 818.63" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="gun_enger"
                            // onClick={() => setModal("gun_enger")}
                            onClick={() =>
                                openLightbox(names.indexOf("gun_enger"))
                            }
                        >
                            <polygon points="530.18 814.4 470.66 779 570.62 672.87 582.96 681.24 646.36 612.1 684.68 633.24 530.18 814.4" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="kinken"
                            // onClick={() => setModal("kinken")}
                            onClick={() =>
                                openLightbox(names.indexOf("kinken"))
                            }
                        >
                            <polygon points="713.74 459.07 669.66 503.26 656.93 488.8 564.46 437.27 497.74 345.46 582.96 311.11 622.59 383.11 713.74 459.07" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="anna_fadijr"
                            // onClick={() => setModal("anna_fadijr")}
                            onClick={() =>
                                openLightbox(names.indexOf("anna_fadijr"))
                            }
                        >
                            <polygon points="840.26 910.83 823.83 839.33 943.17 678.15 979.28 698.85 986.33 760.5 840.26 910.83" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="bjorg"
                            // onClick={() => setModal("bjorg")}
                            onClick={() => openLightbox(names.indexOf("bjorg"))}
                        >
                            <polygon points="716.38 908.58 686.66 859.03 745.68 808.5 769.68 751.81 863.02 654.81 905.08 687.84 797.85 860.02 716.38 908.58" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="signe_sørensen"
                            // onClick={() => setModal("signe_sørensen")}
                            onClick={() =>
                                openLightbox(names.indexOf("signe_sørensen"))
                            }
                        >
                            <polygon points="506.33 302.52 465.37 230.52 408.9 267.3 237.49 416.14 236.45 459.07 395.36 389.71 506.33 302.52" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="helga"
                            // onClick={() => setModal("helga")}
                            onClick={() => openLightbox(names.indexOf("helga"))}
                        >
                            <polygon points="143.47 276.76 84.9 276.76 65.96 331.14 55.83 507.3 108.68 516.54 143.47 276.76" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="sudrum_lauskogen"
                            // onClick={() => setModal("sudrum_lauskogen")}
                            onClick={() =>
                                openLightbox(names.indexOf("sudrum_lauskogen"))
                            }
                        >
                            <polygon points="143.47 276.76 219.65 243.51 344.27 144.87 309.48 99.95 130.25 222.37 93.27 276.76 143.47 276.76" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="anna_johannesen"
                            // onClick={() => setModal("anna_johannesen")}
                            onClick={() =>
                                openLightbox(names.indexOf("anna_johannesen"))
                            }
                        >
                            <polygon points="807.54 329.82 869.19 329.82 872.93 537.02 851.79 579.07 823.83 557.93 820.31 431.99 803.13 419.22 813.7 399.62 807.54 329.82" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="randi_blom"
                            // onClick={() => setModal("randi_blom")}
                            onClick={() =>
                                openLightbox(names.indexOf("randi_blom"))
                            }
                        >
                            <polygon points="428.38 741.57 374.66 781.69 297.59 665.82 233.68 574.23 235.38 503.26 310.81 527.11 320.05 573.35 428.38 690.04 428.38 741.57" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="solveig_ludvigsen"
                            // onClick={() => setModal("solveig_ludvigsen")}
                            onClick={() =>
                                openLightbox(names.indexOf("solveig_ludvigsen"))
                            }
                        >
                            <polygon points="237.49 416.14 224.93 352.72 220.06 306 322.69 184.94 420.9 106.12 452.6 176.58 348.24 286.67 237.49 416.14" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="rosa"
                            // onClick={() => setModal("rosa")}
                            onClick={() => openLightbox(names.indexOf("rosa"))}
                        >
                            <polygon points="159.76 568.5 77.41 556.61 59.8 686.96 147.43 699.73 159.76 568.5" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="elsa_bergh"
                            // onClick={() => setModal("elsa_bergh")}
                            onClick={() =>
                                openLightbox(names.indexOf("elsa_bergh"))
                            }
                        >
                            <polygon points="620.82 594.03 616.64 601.75 568.68 573.05 439.39 720.87 470.66 779 570.62 672.87 582.96 681.24 646.36 612.1 620.82 594.03" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="asta_brant"
                            // onClick={() => setModal("asta_brant")}
                            onClick={() =>
                                openLightbox(names.indexOf("asta_brant"))
                            }
                        >
                            <polygon points="823.83 557.93 794.33 592.72 761.3 553.2 754.25 324.42 807.54 329.82 813.7 399.62 803.13 419.22 820.31 431.99 823.83 557.93" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="maja_larsen"
                            // onClick={() => setModal("maja_larsen")}
                            onClick={() =>
                                openLightbox(names.indexOf("maja_larsen"))
                            }
                        >
                            <polygon points="754.94 346.58 731.36 413.49 665.74 386.19 582.96 311.11 546.02 326 466.25 211.81 501.04 183.18 754.94 346.58" />
                        </g>
                        <g
                            className="lommetorkle__area"
                            id="jerda_hermansen"
                            // onClick={() => setModal("jerda_hermansen")}
                            onClick={() =>
                                openLightbox(names.indexOf("jerda_hermansen"))
                            }
                        >
                            <polygon points="870.29 200.8 851.79 245.05 835.28 226.56 810.84 227.22 575.69 112.94 529.23 87.18 559.61 47.99 592.2 66.04 751.39 136.72 870.29 200.8" />
                        </g>
                    </svg>
                </div>

                <div className="lommetorkle-text">
                    {data.pages.inspirasjon.lommetorkle.title[language] && (
                        <h1
                            className="h2"
                            style={{ marginBottom: "2rem", marginTop: "3rem" }}
                        >
                            {data.pages.inspirasjon.lommetorkle.title[language]}
                        </h1>
                    )}
                    {data.pages.inspirasjon.lommetorkle.description[
                        language
                    ] && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: data.pages.inspirasjon.lommetorkle
                                    .description[language],
                            }}
                        ></div>
                    )}
                </div>
            </>
        );
    };
    return (
        <>
            <SimpleReactLightbox>
                <Comp {...props}></Comp>
            </SimpleReactLightbox>
        </>
    );
};

export default Lommetorkle;
